import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, ActionBar } from "@/components/PageBits";
import StatusBadge from "@/components/StatusBadge";

export default function Conflicts() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/conflicts").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="conflicts-page">
      <PageHeader title="Konflikte" subtitle="Aufträge mit Aufmaß-Differenzen zwischen WhatsApp und KASYS" />
      <div className="bg-white border rounded-md overflow-hidden" style={{ borderColor: "#E2E8F0" }}>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="text-left px-4 py-3">Auftragsnr.</th>
              <th className="text-left px-4 py-3">KLS-ID</th>
              <th className="text-left px-4 py-3">Datum</th>
              <th className="text-left px-4 py-3">Mitarbeiter</th>
              <th className="text-left px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="py-12 text-center text-slate-400">Keine Konflikte vorhanden</td></tr>}
            {items.map((o) => (
              <tr key={o.id} onClick={() => nav(`/orders/${o.id}`)} className="border-t hover:bg-slate-50 cursor-pointer" style={{ borderColor: "#E2E8F0" }}>
                <td className="px-4 py-3 font-semibold">{o.auftragsnummer}</td>
                <td className="px-4 py-3 mono">{o.kls_id}</td>
                <td className="px-4 py-3">{o.ausfuehrungsdatum}</td>
                <td className="px-4 py-3">{[o.mitarbeiter_1, o.mitarbeiter_2, o.mitarbeiter_3, o.mitarbeiter_4].filter(Boolean).join(", ")}</td>
                <td className="px-4 py-3"><StatusBadge status={o.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ActionBar onPrint={() => window.print()} hideNext />
    </div>
  );
}
